module.exports = __webpack_public_path__ + "media/images/blog-list-pic4-738ec18a0aad70f08f198dbb149f7257.png";